import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

function Radio({ options, value, onChange, label, readOnly, disabled, error, helperText }) {
    const hasError = Boolean(error);
    const hText = error || helperText;

    return (
        <div
            className={clsx("radio", {
                error: hasError,
            })}
        >
            {label && <label className="radio__label">{label}</label>}
            <div className="radio__options">
                {options.map((option) => (
                    <label key={option.value} className="radio__option">
                        <input
                            type="radio"
                            readOnly={readOnly}
                            disabled={disabled}
                            value={option.value}
                            checked={value === option.value}
                            onChange={() => onChange(option.value)}
                        />
                        {option.label}
                    </label>
                ))}
            </div>
            {hText && <p className="radio__helper-text">{hText}</p>}
        </div>
    );
}

Radio.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
        })
    ).isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string,
    readOnly: PropTypes.bool,
    disabled: PropTypes.bool,
    error: PropTypes.string,
    helperText: PropTypes.string,
};

Radio.defaultProps = {
    value: "",
    label: "",
    readOnly: false,
    disabled: false,
    error: undefined,
    helperText: undefined,
};

export default Radio;
